import { UuidZ } from "@/types/zod/auth";
import { z } from "zod";

import { SideZ } from "@/types/zod/common";

export const ShockwaveSchemaZ = z.object({
	event_id: UuidZ,
	shockwave_id: UuidZ,
	referring_clinician_id: z.string().uuid("Referring clinician is required"),
	shockwaving_clinician_id: z.union([z.string(), z.null()]).optional(),
});

export type ShockwaveSchemaT = z.infer<typeof ShockwaveSchemaZ>;

export const shockwaveDetailSchema = z.object({
	shockwave_detail_id: UuidZ,
	shockwave_id: UuidZ,
	side: SideZ,
	orthopaedic_area: z.string(),
	site: z.string(),
	subsite: z.string(),
	shockwave_substance: z.string(),
	dose: z.string(),
	unit: z.string(),
});

export type ShockwaveDetailSchemaType = z.infer<typeof shockwaveDetailSchema>;
